import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { toast } from "../utils/toast";
import CartBox from "./CartBox";
import UserProfile from "./UserProfile";

const MobileMenu = ({ isVisible, toggleMenu, menuItems, cartItems, grandTotal, removeItemFromCart, wishlistCount }) => {
    const [metaData, setMetaData] = useState({});
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const toggleSubMenu = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index); // toggle current submenu
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get("/business-settings");
                setSettings(response.data.data.data);
            } catch (err) {
                setError(err);
                toast.error("Failed to load business settings.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (Array.isArray(settings)) {
            const meta = {};
            settings.forEach((setting) => {
                if (setting.type === "header_logo_path") {
                    meta.header_logo_path = setting.value;
                }
                if (setting.type === "contact_address") {
                    meta.contact_address = setting.value;
                }
                if (setting.type === "website_name") {
                    meta.website_name = setting.value;
                }
                if (setting.type === "contact_phone") {
                    meta.contact_phone = setting.value;
                }
                if (setting.type === "contact_email") {
                    meta.contact_email = setting.value;
                }
                if (setting.type === "facebook_link") {
                    meta.facebook_link = setting.value;
                }
                if (setting.type === "twitter_link") {
                    meta.twitter_link = setting.value;
                }
                if (setting.type === "instagram_link") {
                    meta.instagram_link = setting.value;
                }
                if (setting.type === "linkedin_link") {
                    meta.linkedin_link = setting.value;
                }
            });
            setMetaData(meta);
        }
    }, [settings]);

    // Close menu when clicking backdrop
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        
        return () => {
            document.body.style.overflow = '';
        };
    }, [isVisible]);

    if (!isVisible) return null;

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading data</div>;
    }

    return (
        <div className="mobile-menu">
            <div className="menu-backdrop" onClick={toggleMenu}></div>
            <nav className="menu-box">
                <div className="upper-box">
                    <Link to="/">
                        {/* <div className="nav-logo">
                            <img
                                src={metaData.header_logo_path || "/path/to/default/logo.png"}
                                alt={metaData.website_name || "Website"}
                            />
                        </div> */}
                    </Link>
                    <div className="close-btn" onClick={toggleMenu}>
                        <i className="icon fa fa-times"></i>
                    </div>
                </div>
                <div className="middle-box">
                    <Link to="/">
                        <div className="nav-logo">
                            <img
                                src={metaData.header_logo_path || "/path/to/default/logo.png"}
                                alt={metaData.website_name || "Website"}
                            />
                        </div>
                    </Link>
                </div>
                <ul className="midBox">
                    <li>
                        <div className="midBox-item-wrapper">
                            <UserProfile />
                            <p className="midBoxTitle">Account</p>
                        </div>
                    </li>
                    <li>
                        <div className="midBox-item-wrapper">
                            <Link to="/wishlists" className="ui-btn ui-btn wishlist-btn" onClick={toggleMenu}>
                                <span className="icon lnr lnr-icon-heart"></span>
                                <span className="count">{wishlistCount}</span>
                            </Link>
                            <p className="midBoxTitle">Wishlist</p>
                        </div>
                    </li>
                    <li>
                        <div className="midBox-item-wrapper">
                            <CartBox cartItems={cartItems} grandTotal={grandTotal} removeItemFromCart={removeItemFromCart} />
                            <p className="midBoxTitle">Cart</p>
                        </div>
                    </li>
                </ul>
                <ul className="navigation clearfix">
                    {menuItems.map((item, index) => {
                        // For "Sale" items in mobile view, treat as direct link even if it has subMenu
                        const isSale = item.title && item.title.toLowerCase() === "sale";
                        const hasSubMenu = item.subMenu && item.subMenu.length > 0 && !isSale;
                        
                        return (
                            <li key={index} className={`menu-item ${hasSubMenu ? "has-submenu" : ""}`}>
                                <Link
                                    to={item.link}
                                    onClick={(e) => {
                                        if (hasSubMenu) {
                                            e.preventDefault();
                                            toggleSubMenu(index);
                                        } else {
                                            toggleMenu();
                                        }
                                    }}
                                    className="menu-link"
                                >
                                    <span className="menu-link-text">{item.title === "COLLECTION" ? "Collection" : item.title}</span>
                                    {hasSubMenu && (
                                        <span className={`arrow ${openMenuIndex === index ? "open" : ""}`}>
                                            <i className="fa fa-chevron-down"></i>
                                        </span>
                                    )}
                                </Link>

                                {hasSubMenu && (
                                    <ul className={`submenu ${openMenuIndex === index ? "open" : ""}`}>
                                        {item.subMenu.map((subItem, subIndex) => (
                                            <li key={subIndex}>
                                                <Link to={subItem.link} onClick={toggleMenu} className="submenu-link">
                                                    {subItem.title === "COLLECTION" ? "Collection" : subItem.title}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        );
                    })}
                </ul>

                <ul className="contact-list-one">
                    <li>
                        <i className="icon lnr-icon-phone-handset"></i>
                        <span className="title">Call Now</span>
                        <div className="text">
                            <Link to={`tel:${metaData.contact_phone}`}>
                                {metaData.contact_phone}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <i className="icon lnr-icon-envelope1"></i>
                        <span className="title">Send Email</span>
                        <div className="text">
                            <Link to={`mailto:${metaData.contact_email || 'info@vrindaeliving.com'}`}>
                                {metaData.contact_email || 'info@vrindaeliving.com'}
                            </Link>
                        </div>
                    </li>
                    <li>
                        <i className="icon lnr-icon-map-marker"></i>
                        <span className="title">Address</span>
                        <div className="text">Aadhya Handicraft, E-145, RIICO, Industrial Area, Churu, Rajasthan 331022, India</div>
                    </li>
                </ul>
                <ul className="social-links">
                    <li>
                        <Link to={metaData.twitter_link}>
                            <i className="fab fa-twitter"></i>
                        </Link>
                    </li>
                    <li>
                        <Link to={metaData.instagram_link}>
                            <i className="fab fa-instagram"></i>
                        </Link>
                    </li>
                    <li>
                        <Link to={metaData.facebook_link}>
                            <i className="fab fa-facebook"></i>
                        </Link>
                    </li>
                    <li>
                        <Link to={metaData.linkedin_link}>
                            <i className="fab fa-linkedin-in"></i>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default MobileMenu;
